export { EnturLogo as default } from './EnturLogo';
